// Package imports:
import React from 'react';
// Component imports:
import LmdTable from '../../../ui-elements/Table/LmdTable';
import Flag, { FlagNames } from '../../../ui-elements/Flag/Flag';
// Service imports:
import { useApiLmdData } from '../../../services/apiHooks';
import { formatNumber, getTableDate } from '../../../services/utils';
// Type imports:
import { IApiLmdCurrency } from '../../../types/CurrencyTypes';
import { IDefaultProps } from '../../../types/Types';

const CURRENCIES_TO_SHOW = ['AUD','BRL','CAD','CHF','CNY','CZK','DKK','EUR','GBP','HKD','HRK','HUF','ILS','INR','ISK','JMD','JPY','KRW','NGN','NOK','NZD','PLN','RUB','SEK','SGD','THB','TRY','TWD','USD','XDR','ZAR'];

type Props = IDefaultProps;

const Tollgengi: React.FC<Props> = ({
    accessToken,
    refreshRateMs
}) => {
    const [ tollgengiCurrencies ] = useApiLmdData<IApiLmdCurrency[]>(
        `/v1/market_data/v1/keldan/base_currency/TOO/cross_currency_list/[${CURRENCIES_TO_SHOW.join(';')}]/snapshot`,
        accessToken,
        refreshRateMs
    );

    const handleData = () => {
        const { data, error } = tollgengiCurrencies;
        if (data === null) return tollgengiCurrencies;

        const sortedData = [...data].sort((a, b) => 
            (a.Crosscurrency === null && b.Crosscurrency === null)
            ? 0
            : (a.Crosscurrency === null)
            ? -1
            : (b.Crosscurrency === null)
            ? 1
            : (a.Crosscurrency > b.Crosscurrency)
            ? 1
            : -1
        );

        return {
            data: sortedData,
            error
        }
    }

    return (
        <div className='KCL_tollgengi'>
            <LmdTable
                apiData={handleData()}
                columns={[{
                    title: 'Gjaldmiðill',
                    dataAccessor: ({Crosscurrency}) => {
                        return <div className="flag-and-symbol">
                            <span className="flag"><Flag name={Crosscurrency as FlagNames} /></span>
                            <span className="symbol">{Crosscurrency}</span>
                        </div>
                    },
                    textAlign: "left",
                    simpleSortable: ({Crosscurrency}) => Crosscurrency
                }, {
                    title: 'Nafn',
                    dataAccessor: ({Description}) => Description,
                    textAlign: "left",
                    sortable: (a, b) => a.Description?.localeCompare(b.Description ?? '', 'is') ?? -1
                }, {
                    title: 'Gildi',
                    dataAccessor: ({Averagerate}) => formatNumber(Averagerate),
                    simpleSortable: ({Averagerate}) => Averagerate
                }, {
                    title: 'Dags.',
                    dataAccessor: ({Datetimerate}) => getTableDate(Datetimerate, 'DD/MM/YY', '.'),
                    simpleSortable: ({Datetimerate}) => (Datetimerate === null) ? null : new Date(Datetimerate.replace(/ /g, "T")).getTime()
                }]}
            />
        </div>
    );
}

export default Tollgengi;